<template>
  <v-dialog v-model="isOpenDialog" persistent max-width="500px">
    <v-card>
      <v-card-title class="text-h1"></v-card-title>
      <v-card-text class="text-h5">
        <v-icon>mdi-information-outline</v-icon>
        {{ message }}
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="green" text @click="closeDialog">
          {{ $t('common_close') }}
        </v-btn>
        <v-btn color="red" text @click="confirmDialog">
          {{ $t('common_confirm') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'InfoDialog',
  props: {
    isShowDialog: {
      type: Boolean
    },
    message: {
      type: String
    }
  },
  data: () => ({}),
  mounted () {},
  watch: {},
  computed: {
    isOpenDialog () {
      return this.isShowDialog
    }
  },
  methods: {
    closeDialog () {
      this.$emit('closeDialog')
    },
    confirmDialog () {
      this.$emit('confirmDialog')
      this.closeDialog()
    }
  }
}
</script>
